import { useToast } from '@components/index'
import { apiClient } from '@services/api-client'
import { BACK_OFFICE_PREFIX } from '@services/utils'
import { useOnError } from '@services/utils/onError'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import type { ScheduledTask, ScheduledTaskUpdate } from '@features/cron/types'

import { scheduledTasksQueryKey } from '../queries/useScheduledTasks'

export function useUpdateScheduledTask() {
  const toast = useToast()
  const queryClient = useQueryClient()
  const onError = useOnError()
  const { t } = useTranslation('cron')

  async function update({ id, body }: { id: number; body: ScheduledTaskUpdate }) {
    const res = await apiClient.patch<ScheduledTask>(
      `${BACK_OFFICE_PREFIX}scheduled-tasks/${id}`,
      body
    )
    return res.data
  }

  return useMutation({
    mutationFn: update,
    onSuccess: () => {
      toast.success({ message: t('toast.updated') })
      queryClient.invalidateQueries({ queryKey: scheduledTasksQueryKey })
    },
    onError
  })
}
